import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({
    name: 'translator',
    pure: false
})
export class TranslatorPipe implements PipeTransform {

    constructor(private localizationService: LocalizationService) { }

    transform(
        item: any,
        fieldMap: { [language: string]: string }
    ): string {
        if (!item || !fieldMap) {
            return '';
        }

        const currentLang = this.localizationService.getCachedLanguage();
        if (!currentLang) return '';

        // 1. Try the current language field
        const currentFieldName = fieldMap[currentLang];
        if (currentFieldName && item[currentFieldName]) {
            return item[currentFieldName];
        }

        // 2. Fallback to 'en' if current field is empty
        const englishFieldName = fieldMap['en'];
        if (englishFieldName && item[englishFieldName]) {
            return item[englishFieldName];
        }

        // 3. Last resort: try any available field in the map
        for (const lang in fieldMap) {
            const field = fieldMap[lang];
            if (field && item[field]) {
                return item[field];
            }
        }

        return '';
    }
}
